// libs
import { writable } from "svelte/store";

// types
import { InvoicesStatuses, InvoiceTypes } from "@shared/types/Invoice";
import type { Invoice, Counts } from "@shared/types/Invoice";

// baseline invoice data state
export interface InvoiceData {
  invoice?: Invoice;
  invoices: Invoice[];
  availableCredit: any;
  fees: string;
  counts: Counts;
  loaded: boolean;
  failed: boolean;
  currentTab: InvoicesStatuses;
  searchValues: {
    outstanding: string;
    paid: string;
  };
  filters: {
    startDate: string;
    endDate: string;
    order: string;
    direction: string;
    type: InvoiceTypes;
    distributor_ids: string;
  };
  pagination: {
    page: number;
    perPage: number;
    totalEntries: number;
  };
}

// data
const paginationInitialState = {
  page: 1,
  perPage: 15,
  totalEntries: 0,
};
const initialState = {
  invoices: [],
  availableCredit: {},
  fees: "0",
  counts: {
    paid: 0,
    unpaid: 0,
  },
  loaded: false,
  failed: false,
  currentTab: InvoicesStatuses.OUTSTANDING,
  searchValues: {
    outstanding: "",
    paid: "",
  },
  filters: {
    startDate: "",
    endDate: "",
    order: "",
    direction: "",
    type: null,
    distributor_ids: "",
  },
  pagination: paginationInitialState,
};

export const InvoiceStore = writable<InvoiceData>(initialState);

// functions
export const resetInvoiceStore = () => InvoiceStore.set(initialState);
export const setFees = amount => {
  InvoiceStore.update(state => ({
    ...state,
    fees: amount,
  }));
};
export const setCurrentTab = tab => {
  InvoiceStore.update(state => ({
    ...state,
    invoices: [],
    currentTab: tab,
  }));
};
export const resetInvoices = () => {
  InvoiceStore.update(state => ({
    ...state,
    invoices: [],
  }));
};
export const updateSearchValue = (status, value) => {
  InvoiceStore.update(state => ({
    ...state,
    searchValues: {
      ...state.searchValues,
      [status]: value,
    },
  }));
};
